import Vue from "vue";
import Component from "vue-class-component";
import $ from "jquery";
import { ContratAEditerDto } from "../../../dto/GenApi.iNotPaie.Dto/ContratAEditerDto";
import { DemandeEditionTableauDto } from "../../../dto/GenApi.iNotPaie.Dto/DemandeEditionTableauDto";
import { ServicesFactoryInstance } from "../../Controls/ServicesFactory";
import { PropositionEntreeSalarieDto } from "../../../dto/GenApi.iNotPaie.Dto/PropositionEntreeSalarieDto";
import DataTestIDHelper from "../../../Helper/DataTestID/DataTestIDHelper";

@Component
export default class ModalPropositionsEntreeSalarie extends Vue {
	public dataReady = false;
	public listeSalaries: PropositionEntreeSalarieDto[] = [];
	public listeSalariesFiltres: PropositionEntreeSalarieDto[] = [];
	public currentOrderColumn = "NomPrenom";
	public orderingDesc = true;
	public filterName = "";

	public init(): void {
		this.dataReady = false;
		this.listeSalaries = [];
		this.listeSalariesFiltres = [];
		this.chargeListePropositionsEntreeSalarie();
		$("#modalPropositionsEntreeSalarie").modal("show");
	}

	public getClassOfOrder(columnName: string, desc: boolean): string {
		if (columnName == this.currentOrderColumn && this.orderingDesc == desc) {
			return "active";
		}

		return "icons";
	}

	public orderBy(columnName: string): void {
		if (this.currentOrderColumn == columnName) {
			this.orderingDesc = !this.orderingDesc;
		} else {
			this.orderingDesc = true;
		}
		this.currentOrderColumn = columnName;
		this.doOrder();
	}

	public doOrder(): void {
		const orderingDesc = this.orderingDesc;
		const columnName = this.currentOrderColumn;
		if (this.listeSalariesFiltres != undefined) {
			this.listeSalariesFiltres.sort(function (a, b) {
				if (a[columnName] < b[columnName]) {
					return (orderingDesc ? -1 : 1);
				}
				if (a[columnName] > b[columnName]) {
					return (orderingDesc ? 1 : -1);
				}

				return 0;
			});
		}
	}

	public doFilter(): void {
		if (this.filterName == undefined || this.filterName == "") {
			this.listeSalariesFiltres = this.listeSalaries;
		} else {
			const upperedLibelle = this.filterName.toLocaleUpperCase() ?? "";
			this.listeSalariesFiltres = this.listeSalaries.filter(s => (s.NumeroSalarie != undefined && s.NumeroSalarie.toString().indexOf(upperedLibelle) >= 0) ||
				(s.Civilite != undefined && s.Civilite.toUpperCase().indexOf(upperedLibelle) >= 0) ||
				(s.NomPrenom != undefined && s.NomPrenom.toUpperCase().indexOf(upperedLibelle) >= 0) ||
				(s.NomNaissance != undefined && s.NomNaissance.toUpperCase().indexOf(upperedLibelle) >= 0));
		}
		this.$forceUpdate();
		this.doOrder();
	}

	public annuler(): void {
		this.dataReady = true;
		$("#modalPropositionsEntreeSalarie").modal("hide");
	}

	public chargeListePropositionsEntreeSalarie(): void {
		ServicesFactoryInstance.EntreeSalarieService.getListePropositionsEntreeSalarie(data => {
			this.listeSalaries = data;
			this.listeSalariesFiltres = data;
			this.getClassOfOrder(this.currentOrderColumn, true);
			this.doFilter();
			this.dataReady = true;
		}, () => {
			this.dataReady = true;
		});
	}

	public valider(idSalarie?: number) : void {
		this.$emit("creerEntreeSalarie", idSalarie);
		this.annuler();
	}
	public getEmployeeEntryRequestButton(salarie: PropositionEntreeSalarieDto, suffix: string): string {
		return DataTestIDHelper.getEmployeeEntryRequestButton(salarie.NomPrenom, "entryRequest-add-", "-button");
	}
}




// WEBPACK FOOTER //
// ./src/components/modalComponents/modalPropositionsEntreeSalarie/modalPropositionsEntreeSalarie.ts